import React from 'react';

function InvoicePreview({ invoiceData }) {
    const currentDate = new Date();
    const invoiceNumber = `#${Math.floor(1000 + Math.random() * 9000)}`;
    const formattedDate = currentDate.toLocaleDateString('en-GB', { 
        day: '2-digit', 
        month: 'short', 
        year: 'numeric' 
    });

    return (
        <div className="invoice-preview">
            <div className="preview-container">
                <div className="invoice-document">
                    {/* Invoice Header */}
                    <div className="invoice-header-section">
                        <h1 className="invoice-title">INVOICE</h1>
                        <div className="company-info">
                            <p className="company-name">Your Company Name</p>
                            <p className="company-address">123 Business Rd.</p>
                            <p className="company-address">City, Country</p>
                        </div>
                    </div>

                    {/* Invoice Details */}
                    <div className="invoice-details-section">
                        <div className="invoice-meta">
                            <div>
                                <p className="meta-label">Invoice</p>
                                <p className="meta-value">{invoiceNumber}</p>
                            </div>
                            <div>
                                <p className="meta-label">Date</p>
                                <p className="meta-value">{formattedDate}</p>
                            </div>
                        </div>
                    </div>

                    {/* Client Information */}
                    {invoiceData.client && (
                        <div className="client-section">
                            <p className="section-title">BILL TO</p>
                            <p className="client-name">{invoiceData.client.billingName}</p>
                            {invoiceData.client.contact && (
                                <p className="client-detail">{invoiceData.client.contact}</p>
                            )}
                            {invoiceData.client.email && (
                                <p className="client-detail">{invoiceData.client.email}</p>
                            )}
                            {invoiceData.client.mobile && (
                                <p className="client-detail">Mobile: {invoiceData.client.mobile}</p>
                            )}
                            {invoiceData.client.phone && (
                                <p className="client-detail">Phone: {invoiceData.client.phone}</p>
                            )}
                            {invoiceData.client.billingAddress && (
                                <p className="client-detail">{invoiceData.client.billingAddress}</p>
                            )}
                            {invoiceData.client.website && (
                                <p className="client-detail">{invoiceData.client.website}</p>
                            )}
                            {invoiceData.client.taxNumber && (
                                <p className="client-detail">Tax #: {invoiceData.client.taxNumber}</p>
                            )}
                        </div>
                    )}

                    {/* Items Table */}
                    <div className="items-table-section">
                        <table className="items-table">
                            <thead>
                                <tr>
                                    <th className="text-left">Description</th>
                                    <th className="text-center">Qty</th>
                                    <th className="text-right">Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {invoiceData.items.length > 0 ? (
                                    invoiceData.items.map((item) => (
                                        <tr key={item.id}>
                                            <td>
                                                <p className="item-name-preview">{item.name}</p>
                                                {item.description && (
                                                    <p className="item-description-preview">{item.description}</p>
                                                )}
                                            </td>
                                            <td className="text-center">{item.quantity}</td>
                                            <td className="text-right">€{(item.price * item.quantity).toFixed(2)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="text-center empty-state">
                                            No items added yet
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Totals Section */}
                    <div className="totals-section">
                        <div className="totals-row">
                            <span>Subtotal</span>
                            <span>€{invoiceData.subtotal || '0.00'}</span>
                        </div>
                        <div className="totals-row">
                            <span>Tax ({invoiceData.taxRate || 0}%)</span>
                            <span>€{invoiceData.tax || '0.00'}</span>
                        </div>
                        <div className="totals-row total">
                            <span>Total</span>
                            <span>€{invoiceData.total || '0.00'}</span>
                        </div>
                    </div>

                    {/* Payment Terms */}
                    {invoiceData.paymentTerms && (
                        <div className="payment-terms-section">
                            <p className="terms-label">Payment Terms: {invoiceData.paymentTerms}</p>
                        </div>
                    )}

                    {/* Instructions */}
                    {invoiceData.instructions && (
                        <div className="instructions-section">
                            <p className="instructions-label">Instructions:</p>
                            <p className="instructions-text">{invoiceData.instructions}</p>
                        </div>
                    )}
                </div>

                {/* Download Button */}
                <button className="download-button">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    Download PDF
                </button>
            </div>
        </div>
    );
}

export default InvoicePreview;
